// @flow
import waitForAnalytics from './wait'
import type { User } from 'types'

declare var process: any

export function identify(user: User) {
  // sanity check, so code doesn't break if user isn't passed
  if (!user) return
  waitForAnalytics(() => {
    // only pass basic traits as a sanity check and rely on back-end identify calls to pass more
    // meaningful data
    const { email, name } = user
    window.analytics.identify(envUserId(user.id), { email, name })

    if (process.env.NODE_ENV === 'development') {
      console.log('segment identify', envUserId(user.id), { email, name }) // eslint-disable-line
    }
  })
}

function envUserId(userId) {
  if (process.env.NODE_ENV === 'production') return userId
  return `${process.env.NODE_ENV}-${String(userId)}`
}
